import React from 'react'

import getMinMaxLimitsObj from './function/getMinMaxLimitsObj'
import classes from './style.module.css'
import Icon from '../../../../elements/Icon'

import store from '../../../../../redux'
import { currencySelect } from '../../../../../redux/stores/firstScreen/action'
import { strings } from '../../../../../i18n'
import WrapperSelector from '../mobile/MobileSelector/WrapperSelector'
import { showScreenModal } from '../../../../../redux/stores/ScreenModalStore/action'

import Loader from '../../../../../images/icon/loaderBlack.svg'

const { dispatch } = store

const currencySelectHandler = async (currencyCode, side) => {

    const state = store.getState().firstScreen

    let newState = { ...state }
    newState[side.toLowerCase() + 'Currency'] = currencyCode !== 'DEFAULT' ? currencyCode : null

    const oppositeSide = side === 'IN' ? 'OUT' : 'IN'

    if (currencyCode === state[side.toLowerCase() + 'Currency']) {
        newState = {
            ...newState,
            swapCurrencyButtonName: null,
            exchangeWayType: null,
            outDestination: null,
            amount: null,
            equivalentData: null,
            cardData: null,
            payway: null,
            minMaxLimits: null,
        }
        newState[side.toLowerCase() + 'Currency'] = null

        dispatch(currencySelect(newState))
        return
    }

    const currenciesArray = Array.from(new Set(state.allExchangeWays.filter(way => way[side.toLowerCase() + 'Currency'].code === currencyCode).map(way => way[oppositeSide.toLowerCase() + 'Currency'].code)))

    if (currenciesArray.length === 1) {
        newState[oppositeSide.toLowerCase() + 'Currency'] = currenciesArray[0]
    }

    if (newState.inCurrency && newState.outCurrency) {
        const exchangeWay = state.allExchangeWays.find(way => way.inCurrency.code === newState.inCurrency && way.outCurrency.code === newState.outCurrency)
        newState = {
            ...newState,
            swapCurrencyButtonName: exchangeWay.exchangeWayType === 'SELL' ? newState.outCurrency : newState.inCurrency,
            exchangeWayType: exchangeWay.exchangeWayType,
            minMaxLimits: await getMinMaxLimitsObj(state.allExchangeWays, newState.inCurrency, newState.outCurrency, state.payway),
            outDestination: null,
            amount: null,
            equivalentData: null,
            cardData: null
        }
        let exchangeWays = newState.allExchangeWays
        exchangeWays = newState.inCurrency ? exchangeWays.filter(way => way.inCurrency.code === newState.inCurrency) : exchangeWays
        exchangeWays = newState.outCurrency ? exchangeWays.filter(way => way.outCurrency.code === newState.outCurrency) : exchangeWays

        let paywaysArray = Array.from(new Set(exchangeWays.map(way => {
            switch (way.exchangeWayType) {
                case 'BUY':
                    return way.inPaywayCode
                case 'SELL':
                    return way.outPaywayCode
                default:
                    return null
            }
        })))
        if (paywaysArray.length === 1) {
            newState['payway'] = paywaysArray[0]
            newState['minMaxLimits'] = await getMinMaxLimitsObj(newState.allExchangeWays, newState.inCurrency, newState.outCurrency, paywaysArray[0])
        }
    }
    dispatch(currencySelect(newState))
}

// Currency selectors
const CurrencySelectors = (props) => {

    const { state } = props

    let inCurrenciesArray = state.outCurrency ?
        Array.from(new Set(state.allExchangeWays.filter(way => way.outCurrency.code === state.outCurrency).map(way => way.inCurrency.code))) :
        Array.from(new Set(state.allExchangeWays.map(way => way.inCurrency.code)))
    let outCurrenciesArray = state.inCurrency ?
        Array.from(new Set(state.allExchangeWays.filter(way => way.inCurrency.code === state.inCurrency).map(way => way.outCurrency.code))) :
        Array.from(new Set(state.allExchangeWays.map(way => way.outCurrency.code)))

    const inCurrencyModal = () => {

        showScreenModal({
            type: 'SELECT_MODAL',
            data: {
                side: 'IN',
                search: true,
                array: inCurrenciesArray,
                currencySelectHandler: currencySelectHandler
            }
        })
        return
    }

    const outCurrencyModal = () => {

        showScreenModal({
            type: 'SELECT_MODAL',
            data: {
                side: 'OUT',
                search: true,
                array: outCurrenciesArray,
                currencySelectHandler: currencySelectHandler
            }
        })
        return
    }

    const paywayModal = () => {

        let exchangeWays = state.allExchangeWays
        exchangeWays = state.inCurrency ? exchangeWays.filter(way => way.inCurrency.code === state.inCurrency) : exchangeWays
        exchangeWays = state.outCurrency ? exchangeWays.filter(way => way.outCurrency.code === state.outCurrency) : exchangeWays

        let paywaysArray = Array.from(new Set(exchangeWays.map(way => {
            switch (way.exchangeWayType) {
                case 'BUY':
                    return way.inPaywayCode
                case 'SELL':
                    return way.outPaywayCode
                default:
                    return null
            }
        })))

        showScreenModal({
            type: 'SELECT_MODAL',
            data: {
                side: 'PAYWAY',
                search: true,
                array: paywaysArray
            }
        })
        return
    }

    return (
        <>
            <div className={classes.currency__wrapper} >
                <div className={classes.list_in}>
                    <h4>{strings('firstScreen.youGive')}</h4>
                    <div className={classes.list}>
                        {inCurrenciesArray.map((currencyCode, index) => {
                            return (
                                <div className={classes.currency}>
                                    <input type={'radio'}
                                        value={currencyCode}
                                        key={index}
                                        id={currencyCode}
                                        name={'IN'}
                                        onClick={event => currencySelectHandler(event.target.value, 'IN')}
                                        checked={state.inCurrency === currencyCode}
                                    />
                                    <Icon
                                        currencyCode={currencyCode}
                                        checked={state.inCurrency}
                                        name={true}
                                    />
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className={classes.list_out}>
                    <h4>{strings('firstScreen.youGet')}</h4>
                    <div className={classes.list}>
                        {outCurrenciesArray.map((currencyCodeOut, index) => {
                            let currencyCode = currencyCodeOut.toString().toLowerCase()
                            return (
                                <div className={classes.out}>
                                    <input
                                        type={'radio'}
                                        value={currencyCodeOut}
                                        key={index}
                                        id={currencyCode}
                                        name={'OUT'}
                                        onClick={event => currencySelectHandler(event.target.value, 'OUT')}
                                        checked={state.outCurrency === currencyCodeOut}
                                    />
                                    <Icon
                                        currencyCode={currencyCodeOut}
                                        checked={state.outCurrency}
                                        name={true}
                                        out={currencyCode}
                                    />
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
            <div className={classes.mobile__wrapper}>
                {state.loaderCurFrom ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 64 }}>
                        <h3>{strings('mobileExchanger.loading')}</h3>
                        <img style={{ paddingLeft: 10 }} src={Loader} alt='load' height={40} />
                    </div> :
                    <WrapperSelector
                        inCurrencyModal={inCurrencyModal}
                        outCurrencyModal={outCurrencyModal}
                        paywayModal={paywayModal}
                        state={state}
                    />
                }
            </div>
        </>
    )
}

export default CurrencySelectors